if (!customElements.get('m-product-card-slider')) {
  class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.initialized) return;
      this.initSlider();
      this.dataset.initialized = true;
    }

    initSlider() {
      if (typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) {
        this.slider = new MinimogLibs.Swiper(this, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          nested: true
        });
      } else {
        setTimeout(() => this.initSlider(), 500);
      }
    }
  }
  customElements.define('m-product-card-slider', ProductCardSlider);
}
